import './Card.less'
import Card from './Card'
export type { CardProps } from './iCard'

export default Card
